<template>
  <!--  远程搜索下拉框-->
  <el-select
    v-model="selected"
    v-select-load="selectLoad"
    :disabled="disabled"
    :multiple="multiple"
    :size="size"
    collapse-tags
    filterable
    remote
    clearable
    reserve-keyword
    class="remoteSelect"
    :placeholder="placeholder"
    :loading="loading"
    @change="getSelected"
    :remote-method="remoteMethod"
  >
    <el-option
      v-for="item in options"
      :key="item[optionVal]"
      :label="item[optionLab]"
      :value="item[optionVal]"
    />
    <p
      v-if="textLoading && !isLast"
      class="el-loading-text"
    >
      <i class="el-icon-loading" />数据加载中
    </p>
  </el-select>
</template>

<script>
import request from "../scripts/request";
import selectLoad from "../scripts/selectLoad";

export default {
  name: "RemoteSelect",
  mixins: [selectLoad],
  props: {
    value: {
      type: [String, Number, Array],
      default: null,
    },
    api: {
      //请求接口
      type: String,
      required: true,
    },
    requestMethod: {
      //请求方式
      type: String,
      default: "get",
    },
    multiple: {
      //是否多选
      type: Boolean,
      default: false,
    },
    disabled: {
      //是否禁用
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "请输入",
    },
    size: {
      type: String,
      default: "mini",
    },
    optionLab: {
      //选项的标签
      type: String,
      default: "name",
    },
    optionVal: {
      //选项的值
      type: String,
      default: "id",
    },
    queryKeys: {
      //查询参数
      type: Object,
      default() {
        return {};
      },
    },
    queryLab: {
      //查询字段与展示label不一致时传入，根据该字段输入查询
      type: String,
      default: "",
    },
    filterObj: {
      // 筛选条件，用于后端不支持筛选时
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      selected: this.value,
      options: [],
      loading: false,
      textLoading: false,
      isLast: false,
      query: "",
      pageQuery: {
        pageSize: 50,
        pageNum: 1,
      },
    };
  },
  watch: {
    value(val) {
      this.selected = val;
    },
  },
  methods: {
    getSelected(val) {
      let selected = null;
      if (this.multiple) {
        selected = this.options.filter((item) =>
          val.includes(item[this.optionVal])
        );
      } else {
        selected = this.options.find((item) => item[this.optionVal] === val);
      }
      this.$emit("input", val);
      this.$emit("select", selected);
    },
    selectLoad() {
      if (!this.isLast) {
        this.pageQuery.pageNum++;
        this.remoteMethod(this.query, true);
      }
    },
    remoteMethod(query, isAdd) {
      if (query !== "") {
        this.loading = true;
        this.textLoading = true;
        this.query = query;
        let key = this.queryLab || this.optionLab;
        let queryParams = Object.assign(this.queryKeys, this.pageQuery);
        queryParams[key] = query;
        let data = {
          url: this.api,
          method: this.requestMethod,
        };
        if (this.requestMethod === "get") {
          data.params = queryParams;
        } else {
          data.data = queryParams;
        }
        request(data)
          .then((res) => {
            if (res.code === "00000") {
              let data =
                res.data && res.data.records
                  ? res.data.records
                  : res.data
                  ? res.data
                  : [];
              if (!isAdd) {
                this.options = [...data];
              } else {
                this.options = this.options.concat(data);
              }
              if (data.length === 0) {
                this.isLast = true;
              }
            }
            this.filterOptions();
            this.loading = false;
            this.textLoading = false;
          })
          .catch(() => {
            this.loading = false;
            this.textLoading = false;
          });
      } else {
        this.options = [];
      }
    },
    filterOptions() {
      const filter = this.filterObj;
      if (!filter || this.options.length === 0) return;
      this.options = this.options.filter(
        (item) => item[filter.key] === filter.val
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.el-loading-text {
  color: $primaryColor;
  text-align: center;
  .el-icon-loading {
    margin-right: 5px;
  }
}
</style>